import { Box, Typography } from '@mui/material';
import {
  contestLoseWingSrc,
  contestRibbonFoldLeftSrc,
  contestRibbonFoldRightSrc,
  contestWinWingSrc,
  trophyIconSrc,
} from '../../assets/profile';
import ContestWinStat from './ContestWinStat';

/** Figma 11059:2154–2167 — Total contests ribbon with win/lose wings */
export default function ContestRibbon({ totalContests, totalWins, totalLosses }) {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '374.77px',
        left: '30px',
        width: 340,
        height: 66.5,
      }}
    >
      {/* 11059:2167 — trophy */}
      <Box
        component="img"
        src={trophyIconSrc}
        alt=""
        sx={{
          position: 'absolute',
          left: '142.03px',
          top: 0,
          width: '35.94px',
          height: '38.55px',
          objectFit: 'contain',
        }}
      />

      {/* 11059:2155 — win wing */}
      <Box
        component="img"
        src={contestWinWingSrc}
        alt=""
        sx={{
          position: 'absolute',
          left: '-8px',
          top: '29.07px',
          width: '63.87px',
          height: '37.45px',
          objectFit: 'fill',
          zIndex: 0,
        }}
      />

      {/* 11059:2153 — fold after left wing */}
      <Box
        component="img"
        src={contestRibbonFoldLeftSrc}
        alt=""
        sx={{
          position: 'absolute',
          left: '54px',
          top: '29.07px',
          width: '7.98px',
          height: '37.45px',
          objectFit: 'fill',
          zIndex: 2,
        }}
      />

      {/* 11059:2154 — center gradient ribbon */}
      <Box
        sx={{
          position: 'absolute',
          left: '61.86px',
          top: '32.83px',
          width: '196.28px',
          height: '30px',
          background: 'linear-gradient(90deg, #2ee437 0%, #ffd700 50%, #ff3b3b 100%)',
          borderTop: '1px solid #051705',
          borderBottom: '1px solid #051705',
          zIndex: 0,
        }}
      />

      {/* 11059:2152 — fold before right wing */}
      <Box
        component="img"
        src={contestRibbonFoldRightSrc}
        alt=""
        sx={{
          position: 'absolute',
          left: '258px',
          top: '29.07px',
          width: '7.98px',
          height: '37.45px',
          objectFit: 'fill',
          zIndex: 0,
        }}
      />

      {/* 11059:2148 — lose wing */}
      <Box
        component="img"
        src={contestLoseWingSrc}
        alt=""
        sx={{
          position: 'absolute',
          left: '266.13px',
          top: '29.07px',
          width: '63.87px',
          height: '37.45px',
          objectFit: 'fill',
          zIndex: 0,
        }}
      />

      {/* 11059:2159 — TOTAL CONTESTS */}
      <Typography
        sx={{
          position: 'absolute',
          left: '82.45px',
          top: '37.83px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          fontSize: 12,
          lineHeight: '20px',
          letterSpacing: '0.8px',
          color: '#000',
          whiteSpace: 'nowrap',
        }}
      >
        TOTAL CONTESTS
      </Typography>

      {/* 11059:2160 — contest count */}
      <Typography
        sx={{
          position: 'absolute',
          left: '204.62px',
          top: '35.83px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: 16,
          lineHeight: '24px',
          letterSpacing: '0.8px',
          color: '#000',
        }}
      >
        {totalContests}
      </Typography>

      <ContestWinStat wins={totalWins} />

      {/* 11059:2162 — LOSE */}
      <Typography
        sx={{
          position: 'absolute',
          left: '291.08px',
          top: '31.07px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          fontSize: 10,
          lineHeight: '12px',
          color: 'rgba(255,255,255,0.7)',
        }}
      >
        LOSE
      </Typography>

      {/* 11059:2163 — lose count */}
      <Typography
        sx={{
          position: 'absolute',
          left: '268.12px',
          top: '46.52px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
          fontSize: 14,
          lineHeight: '20px',
          letterSpacing: '0.5px',
          color: '#fff',
        }}
      >
        {totalLosses}
      </Typography>
    </Box>
  );
}
